export const ONBOARDING_RESTART_EVENT = 'co:onboarding:restart';